import React from 'react'
import { Form } from "react-bootstrap";
import Spinners from "../components/Spinners";
import { ArrowLeft } from "lucide-react";

const EmailSection = ({handleSubmit,handleEmailChange,handleFeedbackChange,formState,setFormState,error,setStep,step,loading}) => {
  return (
    <Form onSubmit={handleSubmit}>
    <div className="new-font mb-4">
      <h3 className="h5 mb-3 body-font">Email Address</h3>
      <div>
        <Form.Control
          type="email"
          placeholder="Enter your email"
          className="input-div body-font"
          value={formState.email}
          style={{ border: "0px", background: "transparent" }}
          onChange={handleEmailChange}
          required
        />
        <div
          className="w-100"
          style={{ height: "1px", backgroundColor: "lightgray" }}
        ></div>
        {error && (
          <div
            className="w-100 d-flex algn-items-center justify-content-center px-1 py-1 mt-1 rounded"
            style={{
              backgroundColor: "lightcoral",
              color: "red",
              border: "1px solid red",
            }}
          >
            {error}
          </div>
        )}
        <p className="my-3">
          **Please submit your email for getting the complete report on
          your mail
        </p>
        <div className="mt-4">
          <Form.Control
            type="text"
            className="input-div body-font"
            placeholder="Any Feedback or comments"
            value={formState.feedback}
            style={{
              height: "100px",
              textAlign: "start",
              lineHeight: "10px",
            }}
            onChange={handleFeedbackChange}
          />
        </div>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-center gap-2">
      <button
        style={{
          backgroundColor: "#e0e0e4",
        }}
        className="w-100 py-2 rounded mt-4 text-black hover-btn"
        onClick={() => {
          setFormState((prev) => ({
            ...prev,
            currentStep: "filteredSecondSectionQuestions",
          }));
          setStep(step - 1);
        }}
      >
        <ArrowLeft className="ms-3 h-2 w-2 me-2" />
        Back
      </button>
      <button
        className="w-100 py-2 rounded mt-4 border-0 text-white new-btn gap-2 d-flex align-items-center justify-content-center"
        type="submit"
        disabled={!formState.email && error}
      >
        {loading && (
          <div style={{ paddingRight: "10px" }}>
            <Spinners />
          </div>
        )}
        Submit
      </button>
    </div>
  </Form>
  )
}

export default EmailSection